const { mergeMap } = require('rxjs/operators')
const { ofType } = require('redux-observable')

const { alerts: alertsApi } = require('@doctoroncallcom/api')
const {
  GET_ALERT
} = require('./constants')

const {
  getAlertSuccess,
  getAlertError,
} = require('./actions')

const getAlertsList = (action$, state$, { api }) => action$.pipe(
  ofType(GET_ALERT),
  mergeMap(() => alertsApi.getAlerts(api)
    .then(response => getAlertSuccess(response.data))
    .catch(error => getAlertError(error))),
)

module.exports = {
  getAlertsList,
}
